(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-order-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('custom-order');
    if (!root) return;
    const $ = (id) => document.getElementById(id);
    const search = $('mc-rug-search'), results = $('mc-rug-results'), selected = $('mc-selected');
    const status = $('mc-status'), estimate = $('mc-estimate'), send = $('mc-send'), standard = $('mc-standard');
    const labels = $('mc-order-labels').dataset;
    const rates = {'400':395,'700':465,'1200':545,'1500':650,'1700':1560};
    const rootUrl = root.dataset.root.endsWith('/') ? root.dataset.root : root.dataset.root + '/';
    let rug = null, searchTimer = null, searchController = null, lookupController = null, requestId = 0;
    const number = (id) => Number($(id).value);
    const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:'AED', maximumFractionDigits:2}).format(value);
    const clearResults = () => { results.replaceChildren(); results.hidden = true; search.setAttribute('aria-expanded','false'); };
    const setStatus = (value) => { status.textContent = value; };
    const dimensions = () => {
      const length = number('mc-length'), width = number('mc-width'), quantity = number('mc-quantity');
      if (!Number.isFinite(length) || !Number.isFinite(width) || !Number.isInteger(quantity) || length <= 0 || width <= 0 || quantity < 1 || length > 2000 || width > 2000 || quantity > 1000) return null;
      const multiplier = $('mc-unit').value === 'cm' ? 0.01 : 1;
      if (length * multiplier > 30 || width * multiplier > 30) return null;
      return {length:length * multiplier, width:width * multiplier, quantity, area:length * width * multiplier * multiplier};
    };
    const customQuote = (d) => {
      const sizes = rug.variants.filter(v => v.available && Number(v.price) > 0).map(v => {
        const m = v.title.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
        if (!m) return null;
        const area = Number(m[1]) * Number(m[2]) / 10000;
        return area > 0 ? {area, price: Number(v.price) / 100} : null;
      }).filter(Boolean).sort((a, b) => a.area - b.area);
      if (!sizes.length) return null;
      return Math.round(d.area * sizes[0].price / sizes[0].area * d.quantity * 1.30 * 100) / 100;
    };
    const update = () => {
      const d = dimensions();
      estimate.hidden = true; standard.hidden = true; send.disabled = !rug || !d;
      if (!rug) { setStatus(labels.choose); return; }
      if (!d) { setStatus(labels.size); return; }
      const match = rug.variants.find(v => {
        const m = v.title.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
        if (!m) return false;
        const a=Number(m[1])/100,b=Number(m[2])/100;
        return (Math.abs(a-d.length)<.005 && Math.abs(b-d.width)<.005) || (Math.abs(a-d.width)<.005 && Math.abs(b-d.length)<.005);
      });
      if (match) {
        setStatus(match.available ? labels.standard : '');
        estimate.textContent = `${labels.price}: ${money(match.price / 100 * d.quantity)}`;
        estimate.hidden = false;
        if (match.available) {
          standard.href = match.url || rug.url;
          standard.hidden = false;
          send.disabled = true;
        }
        return;
      }
      const quoted = rates[String(rug.reed)] ? customQuote(d) : null;
      if (quoted === null) { setStatus(labels.error); send.disabled = true; return; }
      estimate.textContent = `${labels.price}: ${money(quoted)} (${d.area.toFixed(2)} m² × ${d.quantity})`;
      estimate.hidden = false;
      setStatus(d.area < 12 && d.quantity === 1 ? labels.small : '');
    };
    const selectRug = async (url) => {
      const seq = ++requestId;
      if (lookupController) lookupController.abort();
      lookupController = new AbortController();
      clearResults(); setStatus(labels.loading);
      try {
        const path = new URL(url, location.origin).pathname;
        if (!path.startsWith(rootUrl + 'products/')) throw Error('Invalid product path');
        const response = await fetch(path + '?section_id=custom-rug-product-data', {signal:lookupController.signal});
        if (!response.ok) throw Error('Product details unavailable');
        const documentResult = new DOMParser().parseFromString(await response.text(),'text/html');
        const node = documentResult.querySelector('[data-mc-product]');
        if (!node) throw Error('Product is not eligible');
        const data = JSON.parse(node.textContent);
        if (seq !== requestId || !rates[String(data.reed)]) return;
        rug = data;
        search.value = data.title;
        selected.replaceChildren();
        if (data.image) { const img=document.createElement('img'); img.src=data.image; img.alt=''; selected.append(img); }
        const detail=document.createElement('span'); detail.textContent=`${data.title} · ${data.reed}`; selected.append(detail);
        selected.hidden=false;
        update();
      } catch (error) { if (error.name !== 'AbortError' && seq === requestId) { rug=null; selected.hidden=true; send.disabled=true; setStatus(labels.error); } }
    };
    search.addEventListener('input', () => {
      rug=null; selected.hidden=true; send.disabled=true; estimate.hidden=true; standard.hidden=true;
      clearTimeout(searchTimer); if (searchController) searchController.abort();
      const q=search.value.trim(); if (q.length<2) { clearResults(); setStatus(labels.choose); return; }
      searchTimer=setTimeout(async () => {
        searchController=new AbortController();
        try {
          const url=rootUrl+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show';
          const response=await fetch(url,{signal:searchController.signal});
          if (!response.ok) throw Error('Search unavailable');
          const json=await response.json();
          const products=(json.resources?.results?.products || []).filter(p => p.type === 'Carpet');
          clearResults();
          for (const p of products) {
            const button=document.createElement('button'); button.type='button'; button.className='mc-order__result'; button.setAttribute('role','option');
            if (p.featured_image?.url) { const img=document.createElement('img'); img.src=p.featured_image.url; img.alt=''; button.append(img); }
            const title=document.createElement('span'); title.textContent=p.title; button.append(title);
            button.addEventListener('click',()=>selectRug(p.url)); results.append(button);
          }
          if (!products.length) results.textContent=labels.noResults;
          results.hidden=false;search.setAttribute('aria-expanded','true');
        } catch(error) { if(error.name !== 'AbortError') setStatus(labels.searchError); }
      },250);
    });
    ['mc-length','mc-width','mc-quantity','mc-unit'].forEach(id => $(id).addEventListener('input',update));
    send.addEventListener('click', () => {
      const d=dimensions(); if (!rug || !d || send.disabled) return;
      const match=rug.variants.find(v => {
        const m=v.title.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
        if (!m) return false;
        const a=Number(m[1])/100,b=Number(m[2])/100;
        return (Math.abs(a-d.length)<.005 && Math.abs(b-d.width)<.005) || (Math.abs(a-d.width)<.005 && Math.abs(b-d.length)<.005);
      });
      const total=match ? match.price / 100 * d.quantity : customQuote(d);
      if (total === null) return;
      const lines=[`Custom rug size request`, `Design: ${rug.title}`, `Reed: ${rug.reed}`, `Product: ${new URL(rug.url,location.origin).href}`, `Size: ${d.length.toFixed(2)} × ${d.width.toFixed(2)} m`, `Quantity: ${d.quantity}`, `Estimated price: AED ${total}`, `Name: ${$('mc-name').value.trim() || '—'}`, `Please confirm production feasibility, final quotation and lead time.`];
      window.open('https://wa.me/'+root.dataset.wa+'?text='+encodeURIComponent(lines.join('\n')),'_blank','noopener');
    });
    const handle=new URLSearchParams(location.search).get('rug');
    if (handle && /^[a-z0-9-]+$/i.test(handle)) selectRug(rootUrl+'products/'+handle);
    else setStatus(labels.choose);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-image-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        runMySectionCode();
      });
    } else {
      runMySectionCode();
    }
    function runMySectionCode() {
      document.querySelector('.tc-carousel').style.display = 'block';
      var flkty = new Flickity('.tc-carousel', {
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        avoidReflow: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
